import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Localization from "../../../localization";
import Item from "../../Blog/item";
import IconSpinner from "../../../components/icons/spinner";
import Button from "../../../components/button";
import { getUrl } from "../../../utils/helper";
import { loadBlog } from "../../../redux/actions/blog";
import { getBlogList } from "../../../redux/selectors/blog";

class Blog extends Component {
    componentDidMount() {
        this.props.loadBlog(true);
    }

    _renderLoadMore() {
        const { isLoading, locale, blogList, pagination } = this.props;

        if (isLoading && blogList.length === 0) {
            return (
                <IconSpinner className="mx-auto animate-spin h-25 w-25 text-blue" />
            );
        }

        if (!pagination || pagination.total <= 3) return null;

        return (
            <Button
                text={Localization[locale].home.see_more}
                backgroundColorOver={"bg-blue"}
                borderColor={"border-blue"}
                textStyle={
                    "font-bold text-20 xl:text-17 z-10 transition hover-hover:group-hover:text-white text-blue"
                }
                style={"w-full mx-16 xl:mx-0 xl:w-200"}
                to={getUrl("bookmarks")}
            />
        );
    }

    render() {
        const { locale, blogList } = this.props;

        return (
            <div className="pb-40 xl:pb-60 bg-pink">
                <h1 className="font-judge font-bold text-50 xl:text-100 text-blue text-center py-40 xl:py-80">
                    {Localization[locale].home.blog.toUpperCase()}
                </h1>
                <div className="grid px-16 xl:px-50 md:grid-cols-2 xl:grid-cols-3 gap-x-30 gap-y-50 xl:gap-y-60">
                    {blogList.map((item) => (
                        <Item key={item.id} item={item} />
                    ))}
                </div>
                <div className="flex justify-center mt-40 xl:mt-60">
                    {this._renderLoadMore()}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    blogList: getBlogList(state, 3),
    pagination: state.blog.pagination,
    isLoading: state.blog.isLoading,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            loadBlog,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Blog);
